import { render } from "./ConvoyEditor.vue?vue&type=template&id=24076ee4"
import script from "./ConvoyEditor.vue?vue&type=script&lang=js"
export * from "./ConvoyEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__